export const isUUID = (input: string): boolean =>
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(input)

export const isBoiSerialNumber = (input: string): boolean =>
  /^(VB|NT)\d{6,}[A-Z0-9]+W$/i.test(input)
